<template>
  <div class="row company">
    <div class="col">
      <div>
        <router-link class="btn btn-back" to="/clients/company" tag="button">
          <i class="fa fa-angle-left px-1"></i>
        </router-link>
      </div>
      <div class="row mt-4">
        <div class="col-lg-6 col-sm-12">
          <div class="form-group row mt-4">
            <label
              for="name"
              class="col-4 form-control-label"
            >{{ $t('settings.company_name') }}</label>
            <div class="col-8">
              <input
                type="text"
                class="form-control"
                id="name"
                v-model="company.name"
              />
            </div>
          </div>
          <div class="form-group row">
            <label
              for="address"
              class="col-4 form-control-label"
            >Адрес юридический</label>
            <div class="col-8">
              <input
                type="text"
                class="form-control"
                id="address"
                v-model="company.address"
              />
            </div>
          </div>
          <div class="form-group row">
            <label
              for="unp"
              class="col-4 form-control-label"
            >{{ $t('settings.unp') }}/ИНН</label>
            <div class="col-8">
              <input
                type="text"
                class="form-control"
                id="unp"
                v-model="company.unp"
              />
            </div>
          </div>
          <div class="form-group row">
            <label
              for="bankName"
              class="col-4 form-control-label"
            >{{ $t('settings.bank_details') }}</label>
            <div class="col-8">
              <input
                type="text"
                class="form-control"
                id="bankName"
                v-model="company.bankName"
              />
            </div>
          </div>
          <div class="form-group row">
            <label
              for="bik"
              class="col-4 form-control-label"
            >BIK</label>
            <div class="col-8">
              <input
                type="text"
                class="form-control"
                id="bik"
                v-model="company.bik"
              />
            </div>
          </div>
          <div class="form-group row">
            <label
              for="bankDetails"
              class="col-4 form-control-label"
            >{{ $t('settings.iban_account') }}</label>
            <div class="col-8">
              <input
                type="text"
                class="form-control"
                id="bankDetails"
                v-model="company.bankDetails"
              />
            </div>
          </div>
          <div class="form-group row">
            <label
              for="email"
              class="col-4 form-control-label"
            >{{ $t('settings.contact_e-mail') }}</label>
            <div class="col-8">
              <input
                type="email"
                class="form-control"
                id="email"
                v-model="company.email"
              />
            </div>
          </div>
          <div class="form-group row">
            <label
              for="telephone"
              class="col-4 form-control-label"
            >{{ $t('settings.contact_phone') }}</label>
            <div class="col-8">
              <input
                type="text"
                class="form-control"
                id="telephone"
                placeholder="+375XXXXXXXXX"
                v-model="company.telephone"
              />
            </div>
          </div>
          <div class="form-group row">
            <label
              for="actingDirector"
              class="col-4 form-control-label"
            >В лице</label>
            <div class="col-8">
              <input
                type="text"
                class="form-control"
                id="actingDirector"
                v-model="company.actingDirector"
              />
            </div>
          </div>
          <div class="form-group row">
            <label
              for="actingDocument"
              class="col-4 form-control-label"
            >На основании</label>
            <div class="col-8">
              <input
                type="text"
                class="form-control"
                id="actingDocument"
                v-model="company.actingDocument"
              />
            </div>
          </div>
        </div>
        <div class="col-lg-6 col-sm-12">
          <div class="form-group row mt-4">
            <label
              for="name"
              class="col-4 form-control-label"
            >Псевдоним</label>
            <div class="col-8">
              <input
                type="text"
                class="form-control"
                id="name"
                v-model="company.alias"
              />
            </div>
          </div>
          <div class="form-group row">
            <label
              for="realAddress"
              class="col-4 form-control-label"
            >Адрес фактический</label>
            <div class="col-8">
              <input
                type="text"
                class="form-control"
                id="realAddress"
                v-model="company.realAddress"
              />
            </div>
          </div>
          <div class="form-group row">
            <label
              for="kpp"
              class="col-4 form-control-label"
            >КПП</label>
            <div class="col-8">
              <input
                type="text"
                class="form-control"
                id="kpp"
                v-model="company.kpp"
              />
            </div>
          </div>
          <div class="form-group row">
            <label
              for="okato"
              class="col-4 form-control-label"
            >ОКАТО</label>
            <div class="col-8">
              <input
                type="text"
                class="form-control"
                id="okato"
                v-model="company.okato"
              />
            </div>
          </div>
          <div class="form-group row">
            <label
              for="okpo"
              class="col-4 form-control-label"
            >ОКПО</label>
            <div class="col-8">
              <input
                type="text"
                class="form-control"
                id="okpo"
                v-model="company.okpo"
              />
            </div>
          </div>
          <div class="form-group row">
            <label
              for="ogrn"
              class="col-4 form-control-label"
            >ОГРН</label>
            <div class="col-8">
              <input
                type="text"
                class="form-control"
                id="ogrn"
                v-model="company.ogrn"
              />
            </div>
          </div>
          <div class="form-group row">
            <label
              for="description"
              class="col-4 form-control-label"
            >Описание компании</label>
            <div class="col-8">
              <textarea
                type="text"
                rows="6"
                class="form-control"
                id="description"
                v-model="company.description"
              ></textarea>
            </div>
          </div>
          <div class="row">
            <div class="ml-auto col-8 text-right">
              <button
                type="button"
                class="btn btn-primary px-5"
                @click="updateCompanyInfo"
                :disabled="!isCanUpdateInfo"
              >{{ $t('settings.save') }}</button>
            </div>
          </div>
        </div>
      </div>
      <div
        class="row my-4"
        v-if="id"
      >
        <div class="col">
          <div class="row table-row">
            <div class="col">
              <table class="table company__clients-table">
                <thead>
                  <tr>
                    <th
                      v-for="item in tableHeaderItems"
                      :key="item.name"
                      :style="{'width': item.width * 100 / tableHeaderItems.map(x=>x.width).reduce((a, b) => a + b) + '%'}"
                    >
                      <div class="table-th">{{ item.viewName }}</div>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr class="tr-edit-mode">
                    <td>
                      <input
                        type="text"
                        class="form-control form-control-sm"
                        v-model="client.name"
                      />
                    </td>
                    <td>
                      <masked-input
                        :options="{ alias: 'email',  showMaskOnHover: false, showMaskOnFocus: false, clearIncomplete: true, placeholder: '' }"
                        class="form-control form-control-sm"
                        v-model="client.email"
                      ></masked-input>
                    </td>
                    <td>
                      <input
                        v-model="client.phone"
                        placeholder="+375XXXXXXXXX"
                        class="form-control form-control-sm"
                      />
                    </td>
                    <td>
                      <textarea
                        type="text"
                        rows="1"
                        class="form-control form-control-sm"
                        v-model="client.description"
                      ></textarea>
                    </td>
                    <td align="center">
                      <button
                        type="button"
                        class="btn btn-sm btn-primary px-3"
                        @click="addClient()"
                        :disabled="!isClientValid"
                      >
                        <i class="fa fa-check"></i>
                      </button>
                    </td>
                  </tr>
                  <tr
                    v-for="client in clients"
                    :class="{'tr-edit-mode' : client.inEditing}"
                    :key="client.id"
                  >
                    <td v-if="!client.inEditing">
                      <div
                        class="td-content"
                        :title="client.name"
                      >{{client.name}}</div>
                    </td>
                    <td v-else>
                      <input
                        type="text"
                        class="form-control form-control-sm"
                        v-model="client.name"
                      />
                    </td>
                    <td v-if="!client.inEditing">
                      <div
                        class="td-content"
                        :title="client.email"
                      >{{client.email}}</div>
                    </td>
                    <td v-else>
                      <masked-input
                        :options="{ alias: 'email',  showMaskOnHover: false, showMaskOnFocus: false, clearIncomplete: true, placeholder: '' }"
                        class="form-control form-control-sm"
                        v-model="client.email"
                      ></masked-input>
                    </td>
                    <td v-if="!client.inEditing">
                      <div
                        class="td-content"
                        :title="client.phone"
                      >{{client.phone}}</div>
                    </td>
                    <td v-else>
                      <input
                        v-model="client.phone"
                        placeholder="+375XXXXXXXXX"
                        class="form-control form-control-sm2"
                      />
                    </td>
                    <td v-if="!client.inEditing">
                      <div
                        class="td-content td-content-lg"
                        :title="client.description"
                      >{{client.description}}</div>
                    </td>
                    <td v-else>
                      <textarea
                        type="text"
                        rows="2"
                        class="form-control form-control-sm"
                        v-model="client.description"
                      ></textarea>
                    </td>
                    <td
                      align="center"
                      v-if="!client.inEditing"
                    >
                      <button
                        v-if="isUserCanInviteAdAgent"
                        type="button"
                        class="btn btn-sm btn-outline-primary px-3"
                        @click="setAdAgent(client)"
                        :disabled="client.adAgent || !client.email"
                      >PA</button>
                      <button
                        type="button"
                        class="btn btn-sm btn-primary px-3"
                        @click="editClient(client)"
                      >
                        <i class="fa fa-pencil"></i>
                      </button>
                    </td>
                    <td
                      align="center"
                      v-else
                    >
                      <button
                        type="button"
                        class="btn btn-sm btn-secondary px-3"
                        @click="cancelEditing(client)"
                      >
                        <i class="fa fa-times"></i>
                      </button>
                      <button
                        type="button"
                        class="btn btn-sm btn-primary px-3"
                        @click="saveEditedClient(client)"
                      >
                        <i class="fa fa-check"></i>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <modal
      v-if="showModal"
      @close="onClickNoButton(showModal)"
    >
      <div slot="modal-title">{{ $t('shared.warning') }}</div>
      <div slot="modal-body">{{ $t('shared.do_you_want_leave') }}</div>
      <div slot="modal-footer">
        <button
          type="button"
          class="btn btn-secondary"
          data-dismiss="modal"
          @click="onClickNoButton(showModal)"
        >{{ $t('shared.no') }}</button>
        <button
          type="button"
          class="btn btn-primary"
          @click="onClickYesButton(showModal)"
        >{{ $t('shared.yes') }}</button>
      </div>
    </modal>
  </div>
</template>

<script>
import api from '../../../api'
import roles from '../../../helpers/userRoles'
import modal from '../../../components/modal.vue'
import maskedInput from '../../../components/masked-input.vue'

const mapClient = client => {
  return {
    leid: client.legal_entity ? client.legal_entity.id : null,
    id: client.id,
    name: client.name,
    email: client.email,
    phone: client.telephone,
    description: client.description,
    adAgent: client.ad_agent,
    inEditing: false
  }
}

const mapCompany = company => {
  return {
    leid: company.id,
    name: company.name,
    alias: company.alias,
    unp: company.UNP,
    address: company.address,
    bankName: company.bank,
    bankDetails: company.payment_account,
    telephone: company.telephone,
    email: company.email,
    description: company.description,
    bik: company.bik,
    actingDirector: company.acting_director,
    actingDocument: company.acting_document,
    realAddress: company.real_address,
    kpp: company.kpp,
    okato: company.okato,
    okpo: company.okpo,
    ogrn: company.ogrn
  }
}

const getClient = () => {
  return {
    name: '',
    email: '',
    phone: '',
    description: ''
  }
}

export default {
  name: 'CompanyEdit',
  components: {
    modal,
    'masked-input': maskedInput
  },
  props: {
    id: {
      type: String,
      default: ''
    }
  },
  data: () => {
    return {
      clients: [],
      client: getClient(),
      clientBackups: [],
      tableHeaderItems: [],
      company: {
        leid: undefined,
        name: '',
        alias: '',
        email: '',
        telephone: '',
        address: '',
        bankName: '',
        unp: '',
        bankDetails: '',
        description: '',
        bik: '',
        actingDirector: '',
        actingDocument: '',
        realAddress: '',
        kpp: '',
        okato: '',
        okpo: '',
        ogrn: '',
        isActive: true
      },
      showModal: false,
      isLoading: false
    }
  },
  methods: {
    async updateCompanyInfo () {
      try {
        this.isLoading = true
        const company = {
          name: this.company.name,
          alias: this.company.alias,
          email: this.company.email,
          telephone: this.company.telephone,
          address: this.company.address,
          bank: this.company.bankName,
          UNP: this.company.unp,
          payment_account: this.company.bankDetails,
          description: this.company.description,
          bik: this.company.bik,
          acting_director: this.company.actingDirector,
          acting_document: this.company.actingDocument,
          real_address: this.company.realAddress,
          kpp: this.company.kpp,
          okato: this.company.okato,
          okpo: this.company.okpo,
          ogrn: this.company.ogrn
        }
        if (!this.id) {
          try {
            const resp = await api.post.addCompany(company)
            this.$notify({
              message: 'Клиент создан',
              type: 'success'
            })
            this.$router.push(
              `/clients/company/edit/${resp.data.data.legalEntity.id}`
            )
          } catch (ex) {
            this.$notify({
              message: 'Ошибка создания клиента',
              type: 'danger'
            })
          }
        } else {
          try {
            await api.post.updateCompany(company, this.id)
            this.$notify({
              message: 'Клиент обновлен',
              type: 'success'
            })
          } catch (ex) {
            this.$notify({
              message: 'Ошибка обновления клиента',
              type: 'danger'
            })
          }
        }
        this.isLoading = false
      } catch (ex) {
        this.isLoading = false
      }
    },
    loadCompany () {
      this.isLoading = true
      api.get
        .company(this.id)
        .then(resp => {
          this.company = {
            ...this.company,
            ...mapCompany(resp.data.data.legalEntity)
          }
          this.isLoading = false
        })
        .catch(ex => {
          this.isLoading = false
        })
    },
    loadClients () {
      api.get
        .companyClients(this.id)
        .then(resp => {
          this.clients = resp.data.data.clients
            .map(mapClient)
            .sort(function (a, b) {
              if (a.name.toLowerCase() > b.name.toLowerCase()) {
                return 1
              }
              if (a.name.toLowerCase() < b.name.toLowerCase()) {
                return -1
              }
              return 0
            })
          this.searchText = ''
        })
        .catch(() => this.$notify({
          message: 'Произошла ошибка',
          type: 'danger'
        }))
    },
    editClient (client) {
      const clientIndex = this.clients.findIndex(x => x.id === client.id)
      this.clientBackups[clientIndex] = Object.assign({}, client)
      client.inEditing = true
      this.clients.splice(clientIndex, 1, client)
    },
    cancelEditing (client) {
      const clientIndex = this.clients.findIndex(x => x.id === client.id)
      this.clients.splice(clientIndex, 1, this.clientBackups[clientIndex])
      this.clientBackups[clientIndex] = null
    },
    saveEditedClient (client) {
      const clientInfo = {
        clientName: client.name,
        clientEmail: client.email,
        clientPhone: client.phone,
        description: client.description,
        legalEntity: client.leid
      }
      api.post
        .updateClient(clientInfo, client.id)
        .then(() => {
          const clientIndex = this.clients.findIndex(x => x.id === client.id)
          client.inEditing = false
          this.clients.splice(clientIndex, 1, client)
          this.clientBackups[clientIndex] = null
        })
        .catch(() => {
          this.$notify({
            message: 'Произошла ошибка',
            type: 'danger'
          })
        })
    },
    addClient () {
      const clientInfo = {
        legalEntity: +this.id,
        clientName: this.client.name,
        clientEmail: this.client.email,
        clientPhone: this.client.phone,
        clientDescription: this.client.description
      }

      this.clearClient()

      api.post
        .addClient(clientInfo)
        .then(() => {
          this.loadClients()
        })
        .catch(() => this.$notify({
          message: 'Произошла ошибка',
          type: 'danger'
        }))
    },
    clearClient () {
      this.client = getClient()
    },
    setTableHeader () {
      this.tableHeaderItems = [
        {
          name: 'name',
          viewName: 'ФИО',
          width: 175
        },
        {
          name: 'email',
          viewName: this.$t('home.email'),
          width: 150
        },
        {
          name: 'phone',
          viewName: this.$t('home.phone'),
          width: 150
        },
        {
          name: 'description',
          viewName: this.$t('home.description'),
          width: 200
        },
        {
          name: 'actions',
          viewName: '',
          width: 125
        }
      ]
    },
    clearSearchText () {
      this.searchText = ''
    },
    setAdAgent (client) {
      client.adAgent = true
      api.post
        .updateClient(client, client.id)
        .then(() => {
          const clientIndex = this.clients.findIndex(x => x.id === client.id)
          this.clients.splice(clientIndex, 1, client)
          this.$notify({
            message: 'Приглашение отправлено',
            type: 'success'
          })
        })
        .catch(() => {
          client.adAgent = false
          this.$notify({
            message: 'Клиент уже создан в системе',
            type: 'danger'
          })
        })
    }
  },
  computed: {
    isClientValid () {
      return !!this.client.name && !!(this.client.email || this.client.phone)
    },
    isUserCanEditClients () {
      return (
        this.$store.getters.role === roles.manager ||
        this.$store.getters.role === roles.director
      )
    },
    isUserCanInviteAdAgent () {
      return this.$store.getters.role === roles.director
    },
    isCanUpdateInfo () {
      return (
        !this.isLoading &&
        !!this.company.name &&
        !!(this.company.email || this.company.telephone)
      )
    }
  },
  created: function () {
    if (this.id) {
      this.loadCompany()
      this.loadClients()
    }

    this.setTableHeader()
  },
  beforeRouteLeave (to, from, next) {
    if (this.clients.some(x => x.inEditing)) {
      this.showModal = true
      this.showModal = this.onClickYesButton = () => {
        this.showModal = false
        next()
      }
      this.onClickNoButton = () => {
        this.showModal = false
      }
    } else {
      next()
    }
  }
}
</script>
